<template>
  <div id="listReports" v-show="hasReports">
    <mu-card>
      <mu-card-header
        titleClass="blueTitle largeTitle"
        title="Reports"
        subTitle="A list of reported items">
      </mu-card-header>
      <mu-list id="listReportsScroll">
        <mu-list-item @click.native="goToReport(report)" disableRipple class="report" v-for="(report, index) in reports" :key="`report-${index}`">
          <div slot="title">
            <div v-if="report.comment !== null" v-html="$sanitize(`Comment: ${report.comment.substr(0, 100)}`)"></div>
            <div v-if="report.comment === null">Comment: No comment</div>
          </div>

          <div class="info" slot="default">
            <p>Reported user: {{ report.reported_user }}</p>
            <p>Reported by: {{ report.reported_by }}</p>
            <p>Reason: {{ report.reason }}</p>
            <p>Date: {{ formatDate(report.date) }}</p>
            <p>Time(s) reported: {{ report.amount }}</p>
          </div>
          <mu-icon value="rate_review" slot="right" />
        </mu-list-item>
        <mu-content-block class="loader" v-if="isAppending && !isFinished">
          <mu-circular-progress :size="40" />
        </mu-content-block>
        <div id="scrollDetector"></div>
      </mu-list>
    </mu-card>
  </div>
</template>

<script type="text/javascript">
  import ScrollManager from '../../helpers/ScrollManager';
  import ReportingApi from '../../api/Reporting';

  export default {
    name: 'list-reports',
    data() {
      return {
        scrollingElement: null,
        reports: [],
        isAppending: false,
        isFinished: false,
        params: {
          page: 1,
          per_page: 10,
        }
      }
    },
    methods: {
      formatDate(date) {
        return moment(date).format('lll');
      },
      goToReport(report) {
        let self = this,
            routeName;

        switch (report.type) {
          case 'THREAD_QUESTION' :
            routeName = 'QuestionReport';
              break;
          case 'THREAD_ANSWER' :
            routeName = 'AnswerReport';
            break;
          case 'LIFE_REPLY' :
            routeName = 'LifeReplyReport';
            break;
          case 'LIFE_SUBREPLY' :
            routeName = 'LifeSubReplyReport';
            break;
          default:
              break;
        }

        self.$router.push({
          name: routeName,
          params: {
            id: report.type_id
          }
        });
      },
      loadReports() {
        let self = this;
        self.isAppending = true;
        ReportingApi.getReports(self.params).then((response) => {
          var callback = response.data;
          self.reports.push.apply(self.reports, callback.data);
          self.isAppending = false;
          if( self.params.page === callback.last_page ) {
            self.isFinished = true;
          } else {
            self.params.page += 1;
          }
        }).catch((error) => {
        });
      },
      onScroll() {
        let self = this;
        // only initialize scroll if reports exist
        if(self.hasReports) {
          if( ScrollManager.isElementWithinContentView('#listReportsScroll', '#scrollDetector') ) {
            if( self.isFinished === false ) {
              self.loadReports();
            }
          }
        }
      },
      initMounted() {
        let self = this;
        self.loadReports();
      }
    },
    computed: {
      hasReports() {
        let self = this;
        return self.reports.length !== 0;
      }
    },
    mounted() {
      let self = this;
      self.scrollingElement = document.getElementById('listReportsScroll');
      self.scrollingElement.addEventListener('scroll', self.onScroll);
      self.initMounted();
    },
    beforeDestroy() {
      let self = this;
      if (self.scrollingElement !== null) {
        self.scrollingElement.addEventListener('scroll', self.onScroll);
      }
    }
  }
</script>

<style lang="less">
  #listReports {
    .mu-list {
      height: 350px;
    }
    .report {
      .mu-item-title {
        margin: 0 0 6px;
      }
      .info {
        p {
          margin: 0;
        }
      }
    }
    .loader {
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// ListReports.vue?11b75cf3